export default "__VITE_ASSET__DAuK9IYH__"